'use client';

// 디바이스 감지 관련 상수 및 유틸리티
export const DEVICE_BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1920,
} as const;

export const USER_AGENT_PATTERNS = {
  mobile: /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i,
  tablet: /iPad|Android.*tablet|tablet.*Android|Android.*Pad|Pad.*Android/i,
} as const;

export const RESPONSIVE_PAGES = ['/signin', '/onboarding'] as const;

export interface DeviceInfo {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  userAgent: string;
  screenWidth: number;
}

export function detectDevice(): DeviceInfo {
  if (typeof window === 'undefined') {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: false,
      userAgent: '',
      screenWidth: 0,
    };
  }

  const userAgent = window.navigator.userAgent || '';
  const width = window.innerWidth;

  const isMobileUA = USER_AGENT_PATTERNS.mobile.test(userAgent);
  const isTabletUA = USER_AGENT_PATTERNS.tablet.test(userAgent);

  const isMobileScreen = width < DEVICE_BREAKPOINTS.mobile;
  const isTabletScreen =
    width >= DEVICE_BREAKPOINTS.mobile && width < DEVICE_BREAKPOINTS.tablet;

  // 화면 크기를 우선으로 하되, User Agent도 참고
  const isMobile = isMobileScreen || (isMobileUA && !isTabletUA);
  const isTablet = isTabletScreen || isTabletUA;
  const isDesktop = !isMobile && !isTablet;

  return {
    isMobile,
    isTablet,
    isDesktop,
    userAgent,
    screenWidth: width,
  };
}

export function isResponsivePage(pathname: string): boolean {
  return RESPONSIVE_PAGES.some((page) => pathname.startsWith(page));
}